import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { overProvisionListData } from 'service/service';
import CustomAnalysisTableBase from './CustomAnalysisTableBase';

const columnMapping: Record<string, string> = {
    workspace_name: 'Workspace Name',
    cluster_name: 'Cluster Name',
    job_type: 'Job Type',
    node_type: 'Node Type',
    avg_cpu_utilization: 'Avg CPU Utilization',
    avg_memory_utilization: 'Avg Memory Utilization',
    peak_cpu_utilization: 'Peak CPU Utilization',
    peak_memory_utilization: 'Peak Memory Utilization'
};

const defaultColumns = Object.values(columnMapping);

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const OverProvisionedTablePage = () => {
    const query = useQuery();
    const jobType: any = query.get('type');

    const filterTableDataFn = useCallback((data: any[], mapping: Record<string, string>) =>
        data.map((row: any) => {
            const filtered: Record<string, any> = {};
            Object.keys(mapping).forEach((key) => {
                if (key === "date" && row[key]) {
                    filtered[key] = new Date(row[key]).toLocaleDateString();
                } else if (key === "avg_cpu_utilization" && typeof row[key] === "number") {
                    filtered[key] = row[key].toFixed(2);
                } else if (key === "total_dbu" && typeof row[key] === "number") {
                    filtered[key] = row[key].toLocaleString();
                } else if (key === "total_compute_cost" && typeof row[key] === "number") {
                    filtered[key] = row[key].toLocaleString('en-US', { style: 'currency', currency: 'USD' });
                } else {
                    filtered[key] = row[key];
                }
            });
            return filtered;
        }), []);

    return (
        <CustomAnalysisTableBase
            fetchService={overProvisionListData}
            columnMapping={columnMapping}
            defaultColumns={defaultColumns}
            filterTableDataFn={filterTableDataFn}
            breadcrumbLabel="Over Provisioned - Clusters"
            tableTitle={() => `Over Provisioned${jobType ? ' - ' + jobType : ''}`}
            tableType="over-provision"
            extraParams={{ type: jobType }}
            preserveFilterKey="over_provision_filters"
            isAutoWidth={true}
        />
    );
};

export default OverProvisionedTablePage;
